module.exports = __webpack_public_path__ + "a3296590a3518df437074952d07257b0.png";